module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.lote !== null) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('btn-status-confirmar', {
    ref: "confirmarStatus",
    attrs: {
      "Status": _vm.getStatus,
      "EstadosLote": _vm.getEstadosLote
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-in-down"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.lote.status === _vm.STATUS_RETIRADO) ? _c('img', {
    staticClass: "pull-left m-r",
    attrs: {
      "width": "150",
      "src": require("../assets/lote-retirado.jpg")
    }
  }) : _c('img', {
    staticClass: "pull-left m-r",
    attrs: {
      "src": _vm.lote.fotoDestaque && _vm.lote.fotoDestaque.min,
      "width": "150"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Lote #" + _vm._s(_vm.lote.numero))]), _vm._v(" "), (_vm.lote.grv) ? _c('router-link', {
    attrs: {
      "to": {
        name: _vm.urlGrv,
        params: {
          id: _vm.lote.grv.id
        }
      },
      "target": "_blank",
      "replace": ""
    }
  }, [_c('h2', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("\n                GRV: "), _c('u', {
    style: (("color: " + (_vm.lote.grv && _vm.lote.grv.bloqueadoParaLeilao ? 'red' : '#3103d0')))
  }, [_vm._v(_vm._s(_vm.lote.grv && _vm.lote.grv.numero))]), _vm._v(" "), (_vm.lote.grv && _vm.lote.grv.bloqueadoParaLeilao) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("(GRV bloqueada para leilão)")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.lote.titulo || ''))]), _vm._v(" "), _c('span', {
    staticClass: "label no-radius bg-dark"
  }, [_vm._v(_vm._s(_vm.lote.tipo ? _vm.lote.tipo.nome : ''))]), _vm._v(" "), _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-success"
  }, [_vm._v(_vm._s(_vm.lote.marca ? _vm.lote.marca.nome : ''))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "visible-xs m-t-lg"
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-info pull-right pull-none-xs hidden-print m-r-sm",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.print.apply(null, arguments)
      }
    }
  }, [_vm._v("Imprimir\n              ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editar.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Editar\n              ")]), _vm._v(" "), (_vm.ACL.check('alterar_status_lote', _vm.currentUser.id)) ? _c('btn-status', {
    staticClass: "pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "Status": _vm.getStatus,
      "value": _vm.lote.status
    },
    on: {
      "input": _vm.confirmarAlteracaoStatus
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right pull-none-xs hidden-print m-t-xs m-r",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'leiloes.visualizar',
        params: {
          id: _vm.lote.leilao.id
        }
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")]), _vm._v(" para a tela do\n                leilão\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row m-t-sm"
  }, [_c('h3', {
    attrs: {
      "id": "estado-geral-title"
    }
  }, [_vm._v(_vm._s(_vm.estadoLote.label || "--") + " "), _c('span', {
    staticClass: "label label-sm m-r-xs",
    class: 'bg-' + _vm.getStatus[_vm.lote.status].class
  }, [_vm._v(" ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [(_vm.lote.arremate) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n          Lote arrematado por "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.lote.arremate.arrematante.pessoa.nome))]), _vm._v("\n          (" + _vm._s(_vm.lote.arremate.arrematante.apelido) + "),\n          " + _vm._s(_vm.adjustFirstLetter(_vm.moment(_vm.lote.arremate.dataArremate.date).format('LLLL'))) + ", por "), _c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorArremate)))]), _vm._v(".\n          "), _c('br'), _vm._v("\n          Situação: "), _c('strong', [_vm._v(_vm._s(_vm.Status().StatusArremate[_vm.lote.arremate.status]))])]) : _vm._e(), _vm._v(" "), (_vm.lote.comitente) ? _c('div', {
    staticClass: "wrapper-sm bg-white m-b"
  }, [_c('img', {
    staticClass: "m-r",
    attrs: {
      "src": _vm.lote.comitente.imagem,
      "width": "100"
    }
  }), _vm._v("\n          " + _vm._s(_vm.lote.comitente.pessoa.nome) + "\n        ")]) : _c('div', {
    staticClass: "wrapper-sm bg-white m-b"
  }, [_vm._v("\n          Lote sem comitente\n        ")]), _vm._v(" "), _c('GerenciamentoEntidadeLote', {
    ref: "gerenciamentoEntidadeLote"
  }), _vm._v(" "), _c('GerenciamentoLoteDebito', {
    ref: "gerenciamentoLoteDebito"
  }), _vm._v(" "), _c('GerenciamentoLoteRestricoes', {
    ref: "gerenciamentoLoteRestricoes"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper-sm no-padder m-b"
  }, [_c('div', {
    staticClass: "bg-black"
  }, [_c('div', {
    staticClass: "wrapper-sm bg-dark font-bold text-uppercase"
  }, [_vm._v("Lances")]), _vm._v(" "), _c('div', {
    staticClass: "bg-black pos-rlt",
    attrs: {
      "id": "tableLancesHead"
    }
  }, [_c('table', {
    staticClass: "table table-black bg-black m-b-none"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Apelido")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "scroll-black scroll-lote"
  }, [_c('table', {
    staticClass: "table table-black",
    staticStyle: {
      "margin-top": "-36px"
    },
    attrs: {
      "id": "tableLances"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Apelido")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.lances), function(lance, key) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.moment(lance.data.date).format('L')) + " " + _vm._s(_vm.moment(lance.data.date).format('LTS')))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'arrematante.visualizar',
          params: {
            id: lance.arrematanteId
          }
        }
      }
    }, [_vm._v(_vm._s(lance.apelido) + "\n                    ")]), _vm._v(" "), (key === 0 && _vm.lote.arremate) ? _c('span', {
      staticStyle: {
        "color": "gray"
      }
    }, [_vm._v(" (Boleta "), _c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(_vm.lote.arremate.boleta))]), _vm._v(")")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lance.valor)))]), _vm._v(" "), _c('th', [(_vm.ACL.check('deletar_lance', _vm.currentUser.id)) ? _c('a', {
      staticClass: "text-danger",
      staticStyle: {
        "color": "#ff6362"
      },
      on: {
        "click": function($event) {
          return _vm.deletarLance(lance.id)
        }
      }
    }, [_vm._v("Deletar")]) : _vm._e()])])
  }), _vm._v(" "), ((!_vm.lances || _vm.lances.length === 0) && !_vm.lancesLoading) ? _c('tr', [_c('td', {
    staticClass: "no-borders",
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Nenhum lance")])])]) : _vm._e(), _vm._v(" "), (_vm.lancesLoading) ? _c('tr', [_c('td', {
    staticClass: "no-borders text-center",
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner m-t fa-2x"
  })])]) : _vm._e()], 2)])])])]), _vm._v(" "), (_vm.ACL.check('deletar_lance', _vm.currentUser.id)) ? _c('a', {
    staticClass: "btn btn-danger m-b",
    on: {
      "click": function($event) {
        return _vm.deletarTodosLances(_vm.lote.id)
      }
    }
  }, [_vm._v("Deletar todos os lances")]) : _vm._e(), _vm._v(" "), (_vm.ACL.check('deletar_lance', _vm.currentUser.id)) ? _c('u-button', {
    staticClass: "btn btn-danger m-b",
    attrs: {
      "disabled": !_vm.lote.arremate || _vm.lote.status !== 6
    },
    on: {
      "click": _vm.openFormAlterarArrematante
    }
  }, [_vm._v("Alterar arrematante")]) : _vm._e(), _vm._v(" "), (!_vm.lote.vistoriaCadastrada) ? _c('u-button', {
    staticClass: "btn btn-md btn-info pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cadastrarVistoria.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Cadastrar vistoria do lote\n        ")]) : (_vm.lote.status === _vm.Status().STATUS_VENDIDO && !_vm.lote.extratoLeilao && !_vm.extratoCadastrado) ? _c('u-button', {
    staticClass: "btn btn-md btn-success pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openFormExtratoLeilao.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Cadastrar extrato de leilão\n        ")]) : _vm._e(), _vm._v(" "), (!!_vm.lote.extratoLeilao || _vm.extratoCadastrado) ? _c('u-button', {
    staticClass: "btn btn-md btn-success pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openFormExtratoLeilao.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Extrato já cadastrado para este lote\n        ")]) : _vm._e(), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-md btn-info pull-right pull-none-xs hidden-print m-r-sm",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openDadosConsultaLote.apply(null, arguments)
      }
    }
  }, [_vm._v("Ver dados de consulta\n        ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-md btn-info pull-right pull-none-xs hidden-print m-r-sm",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.executarConsultaLoteDetro.apply(null, arguments)
      }
    }
  }, [_vm._v("Executar consulta de dados DETRO\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('p', [_vm._v("\n              ID: "), _c('strong', [_vm._v(_vm._s(_vm.lote.id))]), _vm._v(" "), _c('br'), _vm._v("\n              Número: "), _c('strong', [_vm._v(_vm._s(_vm.lote.numero))]), _vm._v(" "), _c('br'), _vm._v("\n              Interno: "), _c('strong', [_vm._v(_vm._s(_vm.lote.syncId))]), _vm._v(" " + _vm._s(_vm.lote.syncExtra)), _c('br'), _vm._v("\n              GRV: "), _c('strong', {
    class: {
      'text-danger': _vm.lote.grv && _vm.lote.grv.bloqueadoParaLeilao
    }
  }, [_vm._v(_vm._s(_vm.lote.grv && _vm.lote.grv.numero || '-'))]), _vm._v(" "), (_vm.lote.grv && _vm.lote.grv.bloqueadoParaLeilao) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("(GRV bloqueada para leilão)")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.lote.syncExtra)), _c('br'), _vm._v("\n              Condição: "), _c('strong', [_vm._v(_vm._s(_vm.Status().Condicao[_vm.lote.condicao]))]), _vm._v(" "), _c('br'), _vm._v("\n              Acessórios: "), _c('strong', [_vm._v(_vm._s(_vm.lote.acessorios))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n              Tipo de bem: "), _c('strong', [_vm._v(_vm._s(_vm.lote.tipo ? _vm.lote.tipo.nome : ''))]), _c('br'), _vm._v("\n              Marca: "), _c('strong', [_vm._v(_vm._s(_vm.lote.marca ? _vm.lote.marca.nome : ''))]), _c('br')]), _vm._v(" "), (_vm.lote.modelo) ? _c('div', [_vm._v("\n              Modelo: "), _c('strong', [_vm._v(_vm._s(_vm.lote.modelo.modelo ? _vm.lote.modelo.modelo.nome : ''))]), _c('br'), _vm._v("\n              Fabricação: "), _c('strong', [_vm._v(_vm._s(_vm.lote.modelo.anoFabricacao))]), _c('br'), _vm._v("\n              Ano: "), _c('strong', [_vm._v(_vm._s(_vm.lote.modelo.anoModelo))]), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.lote.grv && _vm.lote.grv.retirada) ? _c('p', [_vm._v("\n              Informações de retirada: "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Veículo possui retirada com status " + _vm._s(_vm.RetiradaStatusTitle(_vm.lote.grv && _vm.lote.grv.retirada.status).toUpperCase()))]), _c('br'), _vm._v(" "), (_vm.ACL.check('temp_alterar_retirada_lote', _vm.currentUser.id)) ? _c('u-button', {
    staticClass: "btn btn-sm btn-success pull-none-xs hidden-print m-r-sm",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openFormRetirada.apply(null, arguments)
      }
    }
  }, [_vm._v("Atualizar Retirada\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n              Informações adicionais:"), _c('br')]), _vm._v(" "), _vm._l((_vm.lote.tipoCampos), function(tipoValor) {
    return _c('div', [_vm._v("\n              " + _vm._s(tipoValor.tipo.nome) + ": "), _c('strong', [_vm._v(_vm._s(tipoValor.valor))]), _c('br')])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n              Observações:"), _c('br'), _c('br'), _vm._v("\n              " + _vm._s(_vm.lote.observacao) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-sm b b-2x"
  }, [_c('div', {
    staticClass: "m-b"
  }, [_c('strong', [_vm._v("Configurações para o site")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Apelido para URL amígável: "), _c('strong', [_c('a', {
    staticClass: "hover-items"
  }, [_vm._v(_vm._s(_vm.lote.slug) + " "), _c('i', {
    staticClass: "fa fa-edit show-hover"
  })])])]), _vm._v(" "), _c('p', [_vm._v("URL pública: "), _c('strong', [_c('a', {
    attrs: {
      "href": 'https://www.consorciorioparkingcarioca.com/lote/' + _vm.lote.id + '/' + _vm.lote.slug,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s('https://www.consorciorioparkingcarioca.com/lote/' + _vm.lote.id + '/' + _vm.lote.slug))])])]), _vm._v(" "), _c('p', [_vm._v("Destaque: "), _c('span', {
    staticClass: "visible-print-inline-block"
  }, [_vm._v(_vm._s(_vm.lote.destaque ? 'Sim' : 'Não'))]), _vm._v(" "), _c('u-button-group', {
    staticClass: "hidden-print",
    attrs: {
      "options": [{
        label: 'Sim',
        value: true,
        class: 'btn-success'
      }, {
        label: 'Não',
        value: false,
        class: 'btn-danger'
      }]
    },
    on: {
      "change": _vm.atualizaDestaque
    },
    model: {
      value: (_vm.lote.destaque),
      callback: function($$v) {
        _vm.$set(_vm.lote, "destaque", $$v)
      },
      expression: "lote.destaque"
    }
  })], 1), _vm._v("\n\n                Vídeos:\n                "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoDestaque),
      expression: "videoDestaque"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.videoDestaque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.videoDestaque = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-success inline",
    on: {
      "click": _vm.salvarVideo
    }
  }, [_vm._v("Salvar")])])]), _vm._v("\n                para mais de um vídeo, separe-os por ,\n\n              ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 text-right"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("% FIPE - Avaliação:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.porcentagemAvaliacao) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Valor Avaliação:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorAvaliacao)) + " " + _vm._s(_vm.porcentagemAvaliacao) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% FIPE - Mínimo:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.porcentagemMinimo) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Valor Mínimo:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorMinimo)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Valor Tabela Fipe:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorTabelaFipe)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Valor Inicial:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorInicial)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Valor Meta:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorMeta)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Valor Incremento:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorIncremento)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Valor Remoção:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorRemocao)))])])]), _vm._v(" "), (_vm.lote.valorArremate > 0) ? _c('tr', [_c('td', [_vm._v("Valor Arremate:")]), _vm._v(" "), _c('td', {
    staticClass: "bg-success"
  }, [_c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorArremate)))])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Taxa de Arremate:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorTaxaArremate)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ICMS:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.lote.icms) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ISS:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.lote.icms) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comissão:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.lote.leilao.comissao) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Valor Comissão:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.comissao)))])])])])])]), _vm._v(" "), (_vm.lote.status === _vm.STATUS_RETIRADO) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "fotos-flex"
  }, [_c('img', {
    staticClass: "pull-left m-r",
    attrs: {
      "width": "150",
      "src": require("../assets/lote-retirado.jpg")
    }
  })])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "m-b m-t-lg"
  }, [_vm._v("Fotos")]), _vm._v(" "), _c('div', {
    staticClass: "fotos-flex"
  }, [_vm._l((_vm.lote.fotos), function(foto, index) {
    return _c('div', {
      staticClass: "foto",
      attrs: {
        "id": 'ltFoto' + foto.id
      }
    }, [((typeof foto.imageInfo.full !== 'undefined' && typeof foto.imageInfo.min !== 'undefined')) ? _c('a', {
      attrs: {
        "href": foto.imageInfo && foto.imageInfo.full.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": foto.imageInfo && foto.imageInfo.min.url
      }
    })]) : _vm._e(), _vm._v(" "), (foto.destaque) ? _c('span', {
      staticClass: "destaque"
    }, [_vm._v("Destaque")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "btn-actions"
    }, [_c('u-button', {
      staticClass: "btn btn-xs btn-block btn-success",
      on: {
        "click": function($event) {
          return _vm.defineFotoDestaque(foto.id, index)
        }
      }
    }, [(!foto.atualizandoDestaque) ? _c('span', [_vm._v("Tornar Destaque")]) : _vm._e(), _vm._v(" "), (foto.atualizandoDestaque) ? _c('span', [_vm._v("Trabalhando nisso...")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
      staticClass: "btn btn-xs btn-block btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeFoto(foto.id)
        }
      }
    }, [_vm._v("Remover")])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "foto"
  }, [(!_vm.isUploadingFoto) ? _c('u-button', {
    staticClass: "btn btn-info fileContainer hidden-print"
  }, [_c('i', {
    staticClass: "fa fa-upload m-r-sm"
  }), _vm._v(" Adicionar nova foto "), _c('input', {
    attrs: {
      "accept": "image/*",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadFotoLote
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isUploadingFoto) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" "), _c('br'), _vm._v("Enviando\n                  foto\n                ")]) : _vm._e()], 1)], 2)])])], 1)]), _vm._v(" "), (_vm.showDadosConsultaLote) ? _c('popup-viewer', {
    attrs: {
      "title": ("Visualização de dados da consulta do lote #" + (_vm.lote.numero || ''))
    },
    on: {
      "close": _vm.closeDadosConsulta
    }
  }, [_c('DadosConsultaLoteDetro', {
    on: {
      "finishSubmit": _vm.closeDadosConsulta,
      "cancel": _vm.closeDadosConsulta
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFormExtratoLeilao) ? _c('popup-viewer', {
    attrs: {
      "title": "Cadastro extrato de leilão"
    },
    on: {
      "close": _vm.closeFormExtratoLeilao
    }
  }, [_c('ExtratoLeilaoForm', {
    attrs: {
      "extratoId": _vm.lote.extratoLeilao && _vm.lote.extratoLeilao.id || null
    },
    on: {
      "finishSubmit": _vm.setExtratoCadastrado,
      "cancel": function($event) {
        _vm.showFormExtratoLeilao = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFormRetirada) ? _c('popup-viewer', {
    attrs: {
      "title": "Formulário de Retirada"
    },
    on: {
      "close": _vm.closeFormRetirada
    }
  }, [_c('FormularioRetirada', {
    attrs: {
      "grvId": _vm.lote.grv && _vm.lote.grv.id
    },
    on: {
      "finishSubmit": _vm.closeFormRetirada
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFormAlterarArrematante) ? _c('popup-viewer', {
    attrs: {
      "title": "Alteração de Arrematante"
    },
    on: {
      "close": _vm.closeFormAlterarArrematante
    }
  }, [_c('FormularioAlterarArrematante', {
    attrs: {
      "lote": _vm.lote
    },
    on: {
      "finishSubmit": _vm.closeFormAlterarArrematante
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ad47445","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/VisualizarLote.vue
// module id = 1756
// module chunks = 18